import { render } from "./CompanyChooser.vue?vue&type=template&id=2d04d6d8&scoped=true&ts=true"
import script from "./CompanyChooser.vue?vue&type=script&lang=ts"
export * from "./CompanyChooser.vue?vue&type=script&lang=ts"

import "./CompanyChooser.vue?vue&type=style&index=0&id=2d04d6d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d04d6d8"]])

export default __exports__